<template>
  <div class="">
    <van-nav-bar
      fixed
      left-arrow
      placeholder
      right-text="退款"
      title="订单详情"
      @click-left="onClickLeft"
    >
      <div slot="right" class="navbar-logo-wrapper">
        <img src="@/assets/images/logo.png" alt="" class="navbar-logo">
      </div>
    </van-nav-bar>
    <section class="order-detail-content" v-if="isEmpty">
      <!-- 订单信息 -->
      <div class="card">
        <div class="title">
          订单信息
        </div>
        <div class="content">
          <div class="order-info-wrapper">
            <div class="order-info">
              <div>
                <div class="order-info-title"> </div>
                <div class="order-info-time">
                  <span style="margin-right: 1rem;">{{ detailInfo.ride_date }}</span>
                  <span>{{ detailInfo.origin_time }}</span> - <span>{{ detailInfo.end_time }}</span>
                </div>
              </div>
              <div class="site-wrapper">
                <div class="start-site">
                  <div class="site-label start"></div>
                  <div class="site-name">{{ detailInfo.origin_address }}</div>
                </div>
                <div class="end-site">
                  <div class="site-label end"></div>
                  <div class="site-name">{{ detailInfo.end_address }}</div>
                </div>
              </div>
            </div>
            <div class="order-info-number" v-if="detailInfo.is_bp!=1">
              <img src="@/assets/images/used.png"
                   alt=""
                   class="used-label"
                   v-if="orderStatus === 'expired' || orderStatus === 'evaluation'">
              <div class="seat-text">座位号</div>
              <div class="number-h" v-if="detailInfo.seat_number != 0">{{ detailInfo.seat_number }}</div>
              <div class="number-h" v-else >候补</div>
            </div>
			<div class="order-info-number" v-else :style="'margin-bottom: 3rem;'">
				<img src="@/assets/images/used.png"
				     alt=""
				     class="used-label"
				     v-if="orderStatus === 'expired' || orderStatus === 'evaluation'">
				<div class="number-h" >补票</div>
			</div>
            <div class="order_status">

            </div>
          </div>
        </div>
        <div class="box"
             v-if="statusName === '待支付' || statusName === '已支付'" >
          <h3 class="start">{{ detailInfo.origin_address }}</h3>
          <div class="animation">
            <img src="@/assets/images/bus.png" alt="">
          </div>
          <h3 class="end">{{ detailInfo.end_address }}</h3>
        </div>
      </div>


     <div class="card" v-if="statusName == '已支付' || detailInfo.order_status =='paid'">
        <div class="title">
          二维码信息
        </div>
        <div class="content tree-background">
          <div class="pay-info" style="text-align: center;">
                 <img :src="detailInfo.qrcode_url" class="qrimg">
          </div>
        </div>
      </div>


      <div class="card">
        <div class="title">
          预约信息
        </div>
        <div class="content tree-background">
          <div class="pay-info">

            <div class="content-line">
              <div class="label">
                乘车状态:
              </div>
              <div class="value">
                {{ statusName }}
              </div>
            </div>
<!--            <div class="content-line">-->
<!--              <div class="label">-->
<!--                路程耗时:-->
<!--              </div>-->
<!--              <div class="value">-->
<!--                约120分钟-->
<!--              </div>-->
<!--            </div>-->
            <div class="content-line">
              <div class="label">
                下单日期:
              </div>
              <div class="value">
                {{ detailInfo.create_time }}
              </div>
            </div>
            <div class="content-line">
              <div class="label">
                乘车日期:
              </div>
              <div class="value">
                {{ detailInfo.ride_date }}
              </div>
            </div>
            <div class="content-line">
              <div class="label">
                发车时间:
              </div>
              <div class="value">
                {{ detailInfo.origin_time }}
              </div>
            </div>
            <div class="content-line">
              <div class="label">
                到站时间:
              </div>
              <div class="value">
                {{ detailInfo.end_time }}
              </div>
            </div>
            <div class="content-line">
              <div class="label">
                车牌号码:
              </div>
              <div class="value">
                {{ detailInfo.car_number }}
              </div>
            </div>
            <div class="content-line">
              <div class="label">
                订单编号:
              </div>
              <div class="value">
                {{ detailInfo.orderid }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

<div v-if="detailInfo.is_bp!=1">
	<section class="utils-button-wrapper safe-area-bottom" v-if="isEmpty">
	  <van-button type="primary"
	              class="continue-button"
	              :disabled="canceling"
	              v-if="orderStatus === 'paid'"
	              @click="onCancelClick">取消订单</van-button>
	  <van-button type="primary"
	              class="continue-button"
	              :disabled="canceling"
	              v-if="orderStatus === 'expired'"
	              @click="onEvaluation">去评价</van-button>
	</section>
</div>

    <section :style="{height: bottomHeight}" v-if="isEmpty"></section>
    <section class="info-detail-empty" v-if="!isEmpty">
      <div class="empty-content-wrapper">
        <img src="@/assets/images/tree.png" alt="" class="empty-logo">
        <div class="empty-text">
          暂时没有预约信息，请先预约
        </div>
        <div class="empty-button-wrapper">
          <van-button type="info"
                      size="small"
                      class="empty-button"
                      @click="goHome">去预约</van-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
 import * as dd from 'dingtalk-jsapi';
import Order from '@/apis/Order';
// import Auth from '@/apis/Auth';

export default {
  name: 'detail',
  data() {
    return {
      detailInfo: {},
      show: false,
      canceling: false,
      bottomHeight: '73px',
      type: Object.keys(this.$route.query),
    };
  },
  mounted() {
    if(this.$route?.query?.id > 0 || this.getUserid > 0){
this.queryData();
    }

    if(this.$route?.query?.tenantTradeNumber > 0 || this.getUserid > 0){
      this.queryData();
    }

    if (this.detailInfo.order_status === 'created' &&  this.detailInfo.is_ticket == 0) {
      this.$router.replace('/order');
    }
  },
  watch:{
       getUserid(newVal, oldVal){
           this.queryData();
       }

  },
  // created() {
  //   const that = this;
  //   if (Object.keys(this.$route.query).includes('tenant')) {
  //     Toast.success(JSON.stringify(this.$route.query));
  //     Toast.success('重新登录一下');
  //     dd.ready(() => {
  //       const toast = Toast.loading({
  //         message: '加载中...',
  //         forbidClick: true,
  //       });
  //       dd.runtime.permission.requestAuthCode({
  //         corpId: 'ding5afe027889e9ac43acaaa37764f94726',
  //         onSuccess(result) {
  //           console.log('钉钉数据获取成功 => ', result);
  //           const { code } = result;
  //           Auth.login(code).then((res) => {
  //             toast.clear();
  //             console.log('res>>>', res?.data);
  //             if (res.code === '1') {
  //               that.$store.commit('auth/setUserInfo', res?.data);
  //               // eslint-disable-next-line max-len
  // eslint-disable-next-line max-len
  //               that.$axios.get(`${process.env.VUE_APP_BASE_API}/get-order-info?userid=${res.data.userid}`).then((resp) => {
  //                 // eslint-disable-next-line no-underscore-dangle
  //                 const _resp = resp.data;
  //                 if (Number(_resp.code) === 1) {
  //                   that.detailInfo = _resp.data;
  //                 }
  //               });
  //             }
  //           }).catch((err) => {
  //             toast.clear();
  //             console.error(err);
  //           });
  //         },
  //         onFail(err) {
  //           console.error('钉钉数据获取失败 ，', err);
  //         },
  //       });
  //     });
  //   }
  // },
  computed: {
    orderStatus() {
      return this.detailInfo?.order_status;
    },
    isEmpty() {
      return +this.detailInfo.id > 0;
    },
    getUserid(){
         return this.$store.getters["auth/userId"];
    },
    statusName() {
      let res = '';
      switch (this.detailInfo?.order_status) {
        case 'created':
          res = '待支付';
          if(this.detailInfo.is_ticket == 0){
             this.$router.replace('/order');
          }

          if(this.detailInfo.is_ticket == 1 && this.detailInfo.ticket_time ==null){
            res = '待补票';
          }

          break;
        case 'cancel':
          res = '已取消';
          break;
        case 'expired':
          res = '已使用';
          break;
        case 'evaluation':
          res = '已评价';
          break;
        default:
          res = '已支付';
          // this.$router.replace('/order');
          break;
      }
      return res;
    },
  },
  methods: {
    goHome() {
      this.$router.push('/home');
    },
    async queryData() {

      const res = await Order.getDetail({id:this.$route?.query?.id,orderid:this.$route?.query?.tenantTradeNumber});
      const { code, data } = res;
      if (Number(code) === 1) {
        this.detailInfo = data;
      }
      return res;
    },
    async cancelOrder() {
      this.canceling = true;
      const toast = Toast.loading({
        message: '取消中',
        forbidClick: true,
      });
      const res = await Order.cancelOrder({ id: this.detailInfo.id });
      const { code, message } = res;
      toast.clear();
      if (Number(code) !== 1) {
        this.canceling = false;
        Toast.fail(message);
        return;
      }
      Toast.success('取消预约成功');
      setTimeout(() => {
        this.$router.replace({
          path: '/orderList',
          query: this.$route.query,
        });
      }, 2000);
    },
    queryHeight() {
      const bottom = document.querySelector('.utils-button-wrapper');
      this.bottomHeight = `${bottom?.clientHeight || 0}px`;
    },
    onClickLeft() {
      if (Object.keys(this.$route.query).includes('tenant')) {
        this.$router.push('/home');
      } else if (this.$route.query.type) {
        this.$router.replace({
          path: '/orderList',
          query: this.$route.query,
        });
      } else if (this.$route.query.isType) {
        this.$router.replace({
          path: '/',
        });
      } else {
        this.$router.back();
      }
    },
    onCancelClick() {
      Dialog.alert({
        title: '提示',
        message: '确认取消预约？',
        showCancelButton: true,
      }).then(() => {
        this.cancelOrder();
      });
    },
    onEvaluation() {
      this.$router.push({
        path: '/evaluation',
        query: {
          id: this.detailInfo.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/mixins.scss";

.navbar-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.navbar-logo {
  width: 28px;
}

.order-detail-content {
  width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 15px;
}

::v-deep {
  .van-nav-bar {
    background-color: #196c44;
  }
  .van-nav-bar__text {
    color: #fff;
  }
}

.utils-button-wrapper {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 1rem;
  @include safe-padding-bottom(15px);
}

.continue-button {
  border-radius: 4px;
  width: 100%;
  border-color: #196c44;
  background: #196c44;
}

.card {
  background: #fff;
  border-radius: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 15px;
  .title {
    padding-left: 18px;
    padding-right: 18px;
    font-weight: bold;
    color: #254725;
    font-size: 15px;
    height: 28px;
    line-height: 28px;
    border-bottom: 1px solid #f1f1f1;
  }
  .qrimg{width:80%}
  .content {
    color: #808080;
    padding: 0.7rem 18px;
    .content-line {
      display: flex;
      flex-wrap: nowrap;
      height: 30px;
      line-height: 30px;
      .label {
        flex-shrink: 0;
        margin-right: 10px;
      }
      .value {
        @include text-ellipsis();
      }
    }

  }
  .box{
    display: flex;
    justify-content: center;
    width: 95%;
    margin: 0 auto;
    position: relative;
    //height: 3rem;
    margin-top: -1rem;
    h3{
      //position: absolute;
      bottom: .5rem;
      white-space: nowrap;
      font-weight: bolder;
      font-size: 1.3rem;
    }
    h3.start{
      //left: 15%;
    }
    h3.end{
      //right: .2rem;
    }
    .animation{
      width: 60%;
      flex-grow: 1;
      //position: absolute;
      position: relative;
      //bottom: 0;
      //left: 50% - 30%;
      img {
        display: block;
        width: 30px;
        position: absolute;
        transition: 0.5s;
        animation: 5s run linear infinite;
        bottom: 1px;
      }
      &:after{
        content: '';
        position: absolute;
        width: 100%;
        background: url("~@/assets/images/line.png") no-repeat center / 100% 100%;
        height: 2px;
        bottom: 0;
        left: -5px;
      }
    }
  }
}

.order-info {
  .value {
    color: #36bafb;
  }

  .order-info-title {
    font-family: Sans-serif;
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
    color: #000000;
  }

  .order-info-time {
    color: #000000;
    font-family: Sans-serif;
    font-size: 1.2rem;
    font-weight: bold;
    padding-top: 1rem;
  }
}
@keyframes run {
  0%{
    left: 1rem;
  }
  100%{
    left: calc(100% - 30px - 1rem);
  }
}
.site-wrapper {
  color: #808080;
  padding-left: 3px;
  margin-top: 0.7rem;
  color: #313131;
  .start-site, .end-site {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 28px;
    position: relative;
    .site-name {}
  }
  .start-site {
    @include start-site();
  }
  .end-site {
    @include end-site();
  }
}

.tree-background {
  background: url("~@/assets/images/tree.png") no-repeat 50% 0;
  background-size: contain;
}

.order-info-wrapper {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  .order-info {
    flex-basis: 0;
    flex-grow: 1;
  }
  .order-info-number {
    flex-shrink: 0;
    color: #fff;
    background-color: #4d7f57;
    text-align: center;
    font-family: Sans-serif;
    padding: 1rem 1rem;
    border-radius: 0.7rem;
    margin-bottom: 1.2rem;
    position: relative;
    .used-label {
      position: absolute;
      bottom: -30px;
      left: 0;
      transform: translateX(-40%);
      //transform: translateX(-50%);
      width: 6rem;
    }
    .seat-text {
      font-size: 1.14rem;
      margin-bottom: 0.4rem;
    }
    .number {
      font-weight: bold;
      font-size: 3rem;
    }
    .number-h {
      font-weight: bold;
      font-size: 2rem;
    }
  }
}

.info-detail-empty {
  height: calc(100vh - 46px);
  display: flex;
  align-items: center;
  justify-content: center;
  .empty-content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .empty-logo {
      width: 10rem;
    }
    .empty-text {
      color: #bbbbbb;
      margin-top: 1rem;
      text-align: center;
    }
    .empty-button-wrapper {
      margin-top: 1rem;
      .empty-button {
        background-color: rgba(#196c44, 0.7);
        border: none!important;
      }
    }
  }
}
</style>
